import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { BsTelephoneInboundFill, BsTelephoneOutbound } from "react-icons/bs";

import Lead from "../../../shared/Lead";
import AudioControl from "./AudioControl";
import PhoneCallButton from "./PhoneCallButton";

const VoicemailCall = ({ task }) => {
  return (
    <>
      <Row className="flex">
        <Col sm={4} md={3} className="bg-grey br">
          <Button id="btn outline" disabled={true}>
            {"Edit Task"}
          </Button>
          <br />
          <br />
        </Col>

        <Col sm={8} md={9} className="task-cols pad20">
          <Lead message={task.label} />
          <div className="mt20">
            <BsTelephoneOutbound className="phone-number-icon" />
            <b>From </b>
            <PhoneCallButton phoneNumber={task.phone_call.from} />}
            {"   "}
            <BsTelephoneInboundFill className="phone-number-icon ml20" />
            <b>To </b>
            <PhoneCallButton phoneNumber={task.phone_call.to} />}
          </div>
          <hr />
          {task.phone_call.recording_url && (
            <AudioControl
              url={`${task.phone_call.recording_url}`}
              id={`voicemail-${ task.id }`}
              caller={task.phone_call.from}
            />
          )}
          <div className="bottom mb10">
            Created at:{" "}
            <b>
              {new Date(task.created_at).toLocaleString([], {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </b>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default VoicemailCall;
